export function moveListItemByOffset(items, index, offset) {
  const source = Array.isArray(items) ? items : [];
  if (!source.length || !Number.isInteger(index) || index < 0 || index >= source.length) {
    return source;
  }
  const normalizedOffset = Number.isFinite(Number(offset)) ? Math.trunc(Number(offset)) : 0;
  const target = Math.max(0, Math.min(source.length - 1, index + normalizedOffset));
  if (target === index) return source;

  const next = source.slice();
  const [item] = next.splice(index, 1);
  next.splice(target, 0, item);
  return next;
}
